export default class EHTPopUp {
	constructor() {
		this.popup = document.getElementById("ehtpopup");
		if (this.popup) {
			this.cname = "popup_" + this.popup.dataset.id;
			this.delay = parseInt(this.popup.dataset.delay);
			this.expires = parseInt(this.popup.dataset.expires);
			this.init();
		}
	}

	init() {
		this.popup.querySelectorAll(".close").forEach((el) => {
			el.addEventListener("click", (e) => {
				this.popup.classList.add("hidden");
				this.popup.classList.remove("flex");
			});
		});

		const randomBoolean = Math.random() < 0.5;

		if (randomBoolean && this.getCookie(this.cname) == "") {
			this.open(this.delay);
			this.setCookie(this.cname, "seen", this.expires);
		}
	}

	open(delay) {
		setTimeout(() => {
			this.popup.classList.remove("hidden");
			this.popup.classList.add("flex");
		}, delay * 1000);
	}

	setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	getCookie(cname) {
		let name = cname + "=";
		let ca = document.cookie.split(";");
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == " ") {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
}
